<template>
    <div>
        <!-- <mds-search-field class="search" v-model="searchValue" /> -->
        <div v-if="isFilteredNavDataEmpty">
            <span class="noSearchResult">No Search Results</span>
        </div>
        <div v-else class="nav-list--clickable-section-header">
            <nav-list :navData="filteredNavData" :contentType="contentType" />
        </div>
    </div>
</template>


<script>
// import MdsSearchField from '@mds/search-field';
import NavList from './nav-list';
import { debounce, isEqual } from 'lodash';
import { CONTENT_TYPE } from '@/data/constants';

import { hasCookie, getCookie } from '../../utils/cookieService.js';

export default {
  name: 'nav-list-search',
  components: {
    // MdsSearchField,
    NavList,
  },
  props: {
    navData: Array,
    contentType: CONTENT_TYPE,
  },
  data() {
    return {
      searchValue: '',
      filteredNavData: [],
    };
  },
  async created() {
      this.filterNavDataByRegion();
      
      this.filterNavDataWithDebounce = debounce(this.filterNavData, 300);
  },
  computed: {
    isFilteredNavDataEmpty() {
      return this.filteredNavData.length === 0;
    },
  },
  methods: {
    filterNavData: function() {

      let navData = [];

      this.navData.forEach(section => {
        const navItems = section.items.filter(item => {
          return item.text.toLowerCase().includes(this.searchValue.toLowerCase());
        });
        if (navItems.length > 0) {
          const sectionCopy = {};
          Object.assign(sectionCopy, section);
          sectionCopy.items = navItems;
          navData.push(sectionCopy);
        }
      });

      this.filteredNavData = navData;
    },
    filterNavDataByRegion: function() {
      // Check if region cookie exists and get its value
      const regionValue = hasCookie('region') ? getCookie('region') : '';

      const filteredData = this.navData.map(section => {
        const filteredItems = section.items.map(item => {
          // Handle different item types
          if (item.sectionItemType === 'SINGLE_LINK') {
            // Single link - check if it has regions and matches
            if (item.regions && item.regions[0] && 
                isEqual(item.regions[0].toLowerCase(), regionValue.toLowerCase())) {
              return item;
            } else if (!item.regions) {
              // No regions specified, include it
              return item;
            }
            return null;
          }
          
          else if (item.sectionItemType === 'SUBLIST') {
            // Sublist - filter the sublist items
            const filteredSublist = item.sublist.filter(subItem => {
              if (subItem.regions && subItem.regions[0] && 
                  isEqual(subItem.regions[0].toLowerCase(), regionValue.toLowerCase())) {
                return true;
              } else if (!subItem.regions) {
                return true;
              }
              return false;
            });
            
            if (filteredSublist.length > 0) {
              return {
                ...item,
                sublist: filteredSublist
              };
            }
            return null;
          }
          
          else if (item.sectionItemType === 'VERSIONED_SUBLIST') {
            // Versioned sublist - filter each version's sublist
            const filteredVersions = item.versions.map(version => {
              const filteredSublist = version.sublist.filter(subItem => {
                if (subItem.regions && subItem.regions[0] && 
                    isEqual(subItem.regions[0].toLowerCase(), regionValue.toLowerCase())) {
                  return true;
                } else if (!subItem.regions) {
                  return true;
                }
                return false;
              });
              
              if (filteredSublist.length > 0) {
                return {
                  ...version,
                  sublist: filteredSublist
                };
              }
              return null;
            }).filter(version => version !== null);
            
            if (filteredVersions.length > 0) {
              return {
                ...item,
                versions: filteredVersions
              };
            }
            return null;
          }
          
          // Default case - no regions specified, include it
          return item;
        }).filter(item => item !== null);

        // Only return section if it has matching items
        if (filteredItems.length > 0) {
          return {
            ...section,
            items: filteredItems
          };
        }
        return null;
      }).filter(section => section !== null);

      this.filteredNavData = filteredData;
    },
  },
  watch: {
    searchValue: function() {
      this.filterNavDataWithDebounce();
    },
    navData: function() {
        // This catches the case where the user clicks a nav tab and changes the entire nav data
        // We could just clear the searchValue and let the watch on it re-filter the
        // nav data, but that introduces noticeable delay in the UI
        this.searchValue = '';
        this.filterNavData();
    }
  }
}
</script>
